/* global isEligibleForFunding */


$(document).ready(function () {
    if (location.href.indexOf('teacher_favorite_new_project') > -1) {
        $('#inspireForm #amount').val(50);
        if (isEligibleForFunding) {
            const togo = $('.togo').attr('data-togo');
            if (togo && parseInt(togo) > 51) {
                $('#simpleWidgetForm #donationAmount').val(50);
            }
        }
    }
});
